import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, concat, interval, Observable, of, Subject, Subscription } from 'rxjs';
import { catchError, first, map, takeWhile } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { DatosUsuarioCliente } from '../model/datos-usuario-cliente';
import { GeneralError } from '../model/error';
import { SearchOperators } from '../model/inventories';
import { Config } from '../model/service-config';
import { SolicitudSsoParameter } from '../model/solicitud-sso-parameter';
import { BearerService } from './bearer-service.service';
import { ClientesService } from './clientes.service';
import { FiltrosConsultaSolicitudesService } from './filtros-consulta-solicitudes.service';
import { RequestStateService } from './request-state.service';
import { ServiceConfigService } from './service-config.service';
import { SessionService } from './session.service';
import { ShoppingElementsService } from './shopping-elements.service';
import { SsoService } from './sso.service';

class AuthResponse {
  token: string;
  expires: Date;

  constructor(json?: string) {
    if (json) {
      const data = JSON.parse(json);
      this.token = data.Token;
      this.expires = new Date(data.Expires);
      // Object.assign(this, json);
    }
  }
}

const NO_USER = 'Anónimo';
const NO_CLIENTE = 'Anónimo';
const NO_LANG = 'es';
const NO_DATE = undefined;
const AUTH_PATH = environment.API_BASE + '/Users/AuthenticateUser';
const AUTH_PATH_SSO_PARAMETERS = environment.API_BASE + '/Users/AuthSsoParameters';
const IS_DOCOUT_PATH = environment.API_BASE + '/Users/IsDocout';
const IS_PROVEEDOR_PATH = environment.API_BASE + '/Users/IsProveedor';
const USER_GESTION = environment.API_BASE + '/Users/isGestionable/';
const isGestionableSolicitud = environment.API_BASE + '/Users/permisoSolicitud/';



const NO_SOPORTE = 'info@docout.es';
const PERM_DETACON = true;


@Injectable()
export class AuthenticationService {
  private inactiveUserSubscription: Subscription;
  private inactiveUserTime = 0;
  private isLoginSubject$ = new BehaviorSubject<boolean>(false);
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  private userId: number | undefined;
  private _userId: number;
  private userName: string;
  private userName$ = new BehaviorSubject<string>(NO_USER);
  private userGroup: number;
  private userPermissionDetailsContainer: boolean;
  private userPermissionDetailsContainer$ = new BehaviorSubject<boolean>(PERM_DETACON);
  private clienteName = 'Nombre Cliente';
  private clienteName$ = new BehaviorSubject<string>(NO_CLIENTE);
  private idiomaUser = 'es';
  private idiomaUser$ = new BehaviorSubject<string>(NO_LANG);
  private emailSoporte = 'emailsoporte@docout.es';
  private emailsoporte$ = new BehaviorSubject<string>(NO_SOPORTE);
  private tieneInventario = false;
  private tieneInventario$ = new BehaviorSubject<boolean>(false);
  private showPriorNoticePassword$ = new BehaviorSubject<boolean>(false);

  private ultimaVisita;
  private ultimaVisita$ = new BehaviorSubject<Date>(NO_DATE);

  private isDocOutUserLogged: boolean;
  private isProveedorUserLogged: boolean;

  private isSupervisor$ = new BehaviorSubject<boolean>(undefined);
  isSupervisor = false;

  private showPriorNoticePassword: boolean;
  private isClosePriorNotice = false;

  private isAdmin$ = new BehaviorSubject<boolean>(false);
  isAdmin = false;
  autorizaciones: boolean;

  _isGestionador: number[] = [];

  private cssUrl = 'assets/css/'; // skin-blue.min.css
  private theme: string;

  private notificationPending$ = new BehaviorSubject<number>(0);
  private importantNotificationPending$ = new BehaviorSubject<number>(0);

  private hasInitialDataWithLogin$ = new BehaviorSubject<boolean>(false);
  private manual: string;
  private busquedaRangoSimple: string;
  private loadFinished$ = new Subject<boolean>();

  private intervallTimer = interval(1000);
  private isUserLogged: boolean;

  private searchOperatorDefault$ = new BehaviorSubject<SearchOperators>(null);
  private searchOperatorDefault: SearchOperators;

  private TienePermisosDevoluciones: boolean;
  private TienePermisosDevoluciones$ = new Subject<boolean>();

  private _isSsoAuthentication: boolean;
  private _canExportInventories: boolean;

  // 🥑🥑
  private tieneBusquedaPorOficina: boolean;

  public permisosPartialLoan: boolean;
  public permisosModificarDireccionCentro: boolean;
  public permisosPrestamoContenedor: boolean;

  constructor(
    private http: HttpClient,
    private jwtHelper: JwtHelperService,
    private clientesservice: ClientesService,
    private router: Router,
    private translateService: TranslateService,
    private sessionService: SessionService,
    private toastr: ToastrService,
    private shoppingCartElementsService: ShoppingElementsService,
    private serviceConfig: ServiceConfigService,
    private requestStateService: RequestStateService,
    private modalService: BsModalService,
    private ssoService: SsoService,
    private bearerService: BearerService,
    private filtrosConsultaSolicitudes: FiltrosConsultaSolicitudesService

  ) {
    const token = this.getToken();
    if (token) {
      this.extractTokenInfo(token);
      this.setLoggin(true);
    }
  }

  private setLoggin(isLogged: boolean) {
    this.isLoginSubject$.next(isLogged);
    this.isUserLogged = isLogged;
    if (isLogged) {
      this.inactiveUserSubscription = this.intervallTimer
        .pipe(takeWhile(() => this.isUserLogged))
        .subscribe(x => {
          this.inactiveUserTime++;
          if (environment.SESSION_TTL <= this.inactiveUserTime) {
            if (console) {
              console.log(
                'Sesión caducada!!!, han transcurrido ' +
                environment.SESSION_TTL +
                ' segundos'
              );
            }
            this.requestStateService.setLastUnauthorizedUrl(
              this.router.routerState.snapshot.url
            );
            this.toastr.clear();
            const inactiveUserTimeText = this.translateService.instant(
              'mensajes.inactiveUserTime'
            );
            const inactiveUserTimeTitle = this.translateService.instant(
              'mensajes.expiredSession'
            );
            this.closeAllModals();

            this.logout(false, true, true);

            this.toastr.warning(inactiveUserTimeText, inactiveUserTimeTitle);
            if (!this.isSsoAuthentication()) {
              this.router.navigate(['/login']);
            }
          }
        });
    } else {
      if (this.inactiveUserSubscription) {
        this.inactiveUserSubscription.unsubscribe();
      }
      this.inactiveUserTime = 0;
    }
  }
  private closeAllModals() {
    for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
      this.modalService.hide(i);
    }
  }

  resetInactiveUserPeriod() {
    this.inactiveUserTime = 0;
  }

  public clientHasInitialData(): Observable<boolean> {
    return this.hasInitialDataWithLogin$.asObservable();
  }

  firstLogin(username: string, password: string): Observable<any> {
    return this.login(username, password, true);
  }

  secondLogin(
    username: string,
    password: string,
    code: string
  ): Observable<any> {
    return this.login(username, password, false, code);
  }

  public isGestionador(idSerie: number): Observable<boolean> {
    if (this._isGestionador.filter(p => p === idSerie).length > 0) {
      return new Observable<boolean>(ob => { ob.next(true); });
    }
    return this.http.get<boolean>(USER_GESTION + idSerie)
      .pipe(map((p) => {
        if (p) {
          this._isGestionador.push(idSerie);
          return p;
        }
      }));
  }

  private login(
    username: string,
    password: string,
    isFirstLogin: boolean,
    code?: string
  ): Observable<any> {
    const auth = JSON.stringify({
      user: username,
      pass: password,
      is_first_authentication: isFirstLogin,
      authentication_code: code
    });
    return this.http
      .post(AUTH_PATH, auth, { headers: this.headers })
      .pipe(
        map((response: any) => {
          if (this.checkGeneralError(response)) {
            return (!!response && response.IsLastAttempt) ? true : undefined;
          }
          if (this.hasMFA(response)) {
            return response;
          }
          // login successful if there's a jwt token in the response
          const resp = new AuthResponse(JSON.stringify(response));
          const token = response && resp.token;
          if (token) {
            //// store username and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem(
              'currentUser',
              JSON.stringify({
                username: username,
                token: token
              })
            );

            this.loadUserData(true, token);
            return false;
          } else {
            // return false to indicate failed login
            this.setLoggin(false);
            return false;
          }
        })
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.setLoggin(false);
          if (error.status === 409 && error.error === 'Throttle') {
            this.toastr.warning(
              this.translateService.instant('warning.waitForLogin')
            );
          }
          return Observable.throw(error || 'Server error');
        })
      );
  }
  private hasMFA(response: any) {
    return response.MFA_TYPE !== undefined && response.IDIOMA;
  }

  checkGeneralError(response: any): boolean {
    if (response.StatusCode && response.ErrorMessage) {
      const error = GeneralError.toModel(JSON.stringify(response));
      const message = `${error.StatusCode} - ${this.translateService.instant(
        'errorsKeys.' + error.ErrorMessage
      )}`;
      this.toastr.warning(message, 'Error');
      return true;
    }
    return false;
  }

  SetThemeClient() {
    // si no hay un item theme recogemos el idcliente
    window.localStorage.setItem(
      'theme',
      this.sessionService.getClientId().toString()
    );
    this.theme = localStorage.getItem('theme');
    let link = document.getElementById('css-theme');
    if (link) {
      link['href'] = this.cssUrl + this.theme + '.css';
    } else {
      const node = document.createElement('link');
      node.href = this.cssUrl + this.theme + '.css'; // insert url in between quotes
      node.rel = 'stylesheet';
      node.id = 'css-theme';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
    link = null;
  }

  getToken(): string {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return currentUser && currentUser.token;
  }
  logout(isInterceptorLogout?: boolean, avoidReload?: boolean, isExpirationSession?: boolean): void {
    this.cleanBasicUserData();
    if (this._isSsoAuthentication && !isInterceptorLogout && !isExpirationSession) {
      const clientId = this.bearerService.getBearer()
        .replace('Bearer', '')
        .trim();
      this.ssoService
        .getUrlLogoutSsoClient(clientId)
        .pipe(first())
        .subscribe(url => {
          window.location.href = url;
        });
    } else if (!this._isSsoAuthentication && !avoidReload) {
      this.router.navigate(['/login']);
    } else if (isExpirationSession) {
      this.router.navigate(['/expirateSessionSso']);
    }
  }
  private cleanBasicUserData(): void {
    this.shoppingCartElementsService.emptyCart();
    // clear token remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.userId = undefined;
    this._userId = undefined;
    this.notificationPending$.next(0);
    this.importantNotificationPending$.next(0);
    this.userName$.next(NO_USER);
    this.setLoggin(false);
    this.isDocOutUserLogged = undefined;
    this.isProveedorUserLogged = undefined;
    this.serviceConfig.resetServiceConfig();
    this.hasInitialDataWithLogin$.next(false);
    this.tieneInventario = false;
    this.tieneInventario$.next(false);
    this._canExportInventories = false;
    const lang = this.translateService.getBrowserLang();
    this.translateService.use(lang).subscribe();
    this.filtrosConsultaSolicitudes.resetFilters();
  }

  public getClientSearchOperator(): Observable<SearchOperators> {
    return this.searchOperatorDefault$.asObservable();
  }

  public getUserId(): number {
    return this._userId;
  }

  public getEmailSoporte(): string {
    return this.emailSoporte;
  }

  public getTieneInventario(): Observable<boolean> {
    return this.tieneInventario$.asObservable();
  }

  public getNotificationPending(): Observable<number> {
    return this.notificationPending$.asObservable();
  }

  public setNotificationPending(numberNotificationPending: number) {
    this.notificationPending$.next(numberNotificationPending);
  }

  public getPermissionContainerDetails(): boolean {
    return this.userPermissionDetailsContainer;
  }

  public getImportantNotificationPending(): Observable<number> {
    return this.importantNotificationPending$.asObservable();
  }

  public setImportantNotificationPending(
    numberImportantNotificationPending: number
  ) {
    this.importantNotificationPending$.next(numberImportantNotificationPending);
  }

  public getUserName(): Observable<string> {
    return this.userName$.asObservable();
  }

  public getClienteName$(): Observable<string> {
    return this.clienteName$.asObservable();
  }

  public getClienteName(): string {
    return this.clienteName;
  }

  public getDateLastVisited(): Observable<Date> {
    return this.ultimaVisita$.asObservable();
  }

  public getIdiomaUser$(): Observable<string> {
    return this.idiomaUser$.asObservable();
  }

  public getIdiomaUser(): string {
    return this.idiomaUser;
  }
  // ------
  public isLoggedIn(): Observable<boolean> {
    return this.isLoginSubject$.asObservable();
  }
  public isSupervisorUserObs(): Observable<boolean> {
    return this.isSupervisor$.asObservable();
  }

  public isSupervisorUser(): boolean {
    return this.isSupervisor;
  }

  public isAdminUserObs(): Observable<boolean> {
    return this.isAdmin$.asObservable();
  }

  public isAdminUser(): boolean {
    return this.isAdmin;
  }

  public hasAutorizaciones(): boolean {
    return this.autorizaciones;
  }

  public canExportInventories(): boolean {
    return this._canExportInventories;
  }

  /**
   * Return a boolean reflecting whether or not the token is expired
   */
  public isAuthenticated(): boolean {
    const token = this.getToken();
    return token && !this.jwtHelper.isTokenExpired(token);
  }

  public SetEnviromentVariables() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.userName = currentUser.username;
    this.userName$.next(this.userName);

    this.loadUserData(false);
  }

  public getManual(): string {
    return this.manual;
  }

  public getBusquedaRangoSimple(): string {
    return this.busquedaRangoSimple;
  }

  public isLoadFinished(): Observable<boolean> {
    return this.loadFinished$.asObservable();
  }

  public isReturnsAvailable(): boolean {
    return this.TienePermisosDevoluciones;
  }

  private initializeEnviromentVariables(
    datosUsuarioCliente: DatosUsuarioCliente
  ) {
    this.setCurrentUserInStorage(datosUsuarioCliente.username);
    this._isSsoAuthentication = datosUsuarioCliente.isSsoAuthentication;
    this._canExportInventories = datosUsuarioCliente.canExportInventories;
    this._userId = datosUsuarioCliente.idUsuario;
    this.sessionService.setClientId(datosUsuarioCliente.idCliente);
    this.clienteName = datosUsuarioCliente.nombreCliente;
    this.clienteName$.next(datosUsuarioCliente.nombreCliente);
    this.isDocOutUserLogged = datosUsuarioCliente.isDocout;
    this.isSupervisor$.next(datosUsuarioCliente.isSupervisor);
    this.isSupervisor = datosUsuarioCliente.isSupervisor;
    this.isAdmin$.next(datosUsuarioCliente.isAdmin);
    this.isAdmin = datosUsuarioCliente.isAdmin;
    this.TienePermisosDevoluciones =
      datosUsuarioCliente.TienePermisosDevoluciones;
    this.TienePermisosDevoluciones$.next(
      datosUsuarioCliente.TienePermisosDevoluciones
    );
    this.idiomaUser = datosUsuarioCliente.idioma;
    this.idiomaUser$.next(datosUsuarioCliente.idioma);
    this.userName = datosUsuarioCliente.nombreUsuario;
    this.userName$.next(datosUsuarioCliente.nombreUsuario);
    this.ultimaVisita = datosUsuarioCliente.fechaUltimaVisita;
    this.ultimaVisita$.next(datosUsuarioCliente.fechaUltimaVisita);
    this.notificationPending$.next(
      datosUsuarioCliente.NotificacionesPendientesLeer
    );
    this.importantNotificationPending$.next(
      datosUsuarioCliente.NotificacionesImportantesPendientesLeer
    );
    this.tieneInventario = datosUsuarioCliente.Inventarios;
    this.tieneInventario$.next(datosUsuarioCliente.Inventarios);
    this.emailSoporte = datosUsuarioCliente.EmailSoporte;
    this.emailsoporte$.next(datosUsuarioCliente.EmailSoporte);
    this.userPermissionDetailsContainer =
      datosUsuarioCliente.GetContainerDetails;
    this.autorizaciones = datosUsuarioCliente.autorizaciones;
    this.showPriorNoticePassword =
      datosUsuarioCliente.preavisoExpiracionPassword;
    this.showPriorNoticePassword$.next(
      this.showPriorNoticePassword && !this.isClosePriorNotice
    );
    localStorage.setItem('idioma', datosUsuarioCliente.idioma);
    this.manual = datosUsuarioCliente.manual;
    this.busquedaRangoSimple = datosUsuarioCliente.busquedaRangoSimple;
    this.searchOperatorDefault = datosUsuarioCliente.operadorBusquedaDefault;
    this.searchOperatorDefault$.next(this.searchOperatorDefault);
    // 🥑🥑
    this.tieneBusquedaPorOficina = datosUsuarioCliente.busquedaPorOficinas;
    this.SetThemeClient();
    this.permisosPartialLoan = datosUsuarioCliente.permisoPrestamoParcial;
    this.permisosModificarDireccionCentro = datosUsuarioCliente.permisoPuedeModificarDirecciones;
    this.permisosPrestamoContenedor = datosUsuarioCliente.permisoPrestamoContenedorInventario;
    this.isProveedorUserLogged = datosUsuarioCliente.isProveedorUser;
  }
  private setCurrentUserInStorage(username: string) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const token = currentUser && currentUser.token;
    const tokenToSave = token ? token : undefined;
    if (tokenToSave) {
      localStorage.setItem(
        'currentUser',
        JSON.stringify({
          username: username,
          token: tokenToSave
        })
      );
    }
  }

  private extractTokenInfo(token: string) {
    const decode = this.jwtHelper.decodeToken(token);
    if (decode.hasOwnProperty('sub')) {
      this.userId = decode.sub;
    }
    if (decode.hasOwnProperty('un')) {
      this.userName = decode.un;
      this.userName$.next(decode.un);
    }
    if (decode.hasOwnProperty('jti')) {
      this.userGroup = decode.jti;
    }
  }

  isDocOutUser(): Promise<Boolean> {
    return new Promise<Boolean>(resolve => {
      if (this.isDocOutUserLogged !== undefined) {
        resolve(this.isDocOutUserLogged);
      } else {
        this.getIsDocOutUser()
          .pipe(first())
          .subscribe((isdocUser: boolean) => {
            this.isDocOutUserLogged = isdocUser;
            resolve(isdocUser);
          });
      }
    });
  }

  public closePriorNotice() {
    this.isClosePriorNotice = true;
    this.showPriorNoticePassword$.next(false);
  }

  public hasShowPriorNotice(): Observable<boolean> {
    return this.showPriorNoticePassword$.asObservable();
  }

  private getIsDocOutUser(): Observable<boolean> {
    return this.http.get<boolean>(IS_DOCOUT_PATH);
  }

  // 🥑🥑 SRR RECUPERAR ROL DE BUSQUEDA
  public getTieneBusquedaOficina(): boolean {
    return this.tieneBusquedaPorOficina;
  }

  public redirectToLoadUserData(isLoginAccess: boolean, token?: string): any {
    this.loadUserData(isLoginAccess, token);
    this.isLoadFinished()
      .pipe(first())
      .subscribe(result => {
        this.router.navigate([
          'docout',
          { outlets: { contenido: ['redirector'] } }
        ]);
      });
  }

  public loadUserData(isLoginAccess: boolean, token?: string): any {
    this.clientesservice.getMyClient().subscribe(
      (datosUsuarioCliente: DatosUsuarioCliente) => {
        this.initializeEnviromentVariables(datosUsuarioCliente);
        const dataCalls: Map<number, Observable<any>> = new Map();

        this.translateService
          .getTranslation(this.idiomaUser)
          .subscribe(result => {
            this.translateService.setTranslation(this.idiomaUser, result, true);
          });

        dataCalls.set(
          0,
          this.translateService.reloadLang(this.idiomaUser).pipe(
            catchError((response: Response) => {
              return of(-1);
            })
          )
        );

        dataCalls.set(
          1,
          this.serviceConfig.getConfig(datosUsuarioCliente.idCliente).pipe(
            catchError((response: Response) => {
              return of(-1);
            })
          )
        );
        const output: Observable<any> = concat(
          dataCalls.get(0),
          dataCalls.get(1)
        );

        let indiceEjecucion = 0;
        output.subscribe(resultSecuencial => {
          if (resultSecuencial.constructor.name == Config.name) {
            this.serviceConfig.setServiceConfig(resultSecuencial as Config);
          } // else {
          // this.translateService.use(resultSecuencial);
          // }
          if (indiceEjecucion === dataCalls.size - 1) {
            if (token) {
              this.extractTokenInfo(token);
            }
            this.hasInitialDataWithLogin$.next(true);
            this.setLoggin(true);
            this.putAccessUrl(isLoginAccess);
          }

          indiceEjecucion++;
        });
        this.loadFinished$.next(true);
      },
      error => {
        this.bearerService.setBearer('DocoutBearer ');
        this.setLoggin(false);
        this.logout();
        this.loadFinished$.next(false);
      }
    );
  }

  private putAccessUrl(isLoginAccess: boolean) {
    if (isLoginAccess) {
      const lastUnauthorizedUrl = this.requestStateService.getLastUnauthorizedUrl();
      if (lastUnauthorizedUrl && lastUnauthorizedUrl.trim().length > 0) {
        this.router.navigateByUrl(lastUnauthorizedUrl);
        this.requestStateService.clearLastUnauthorizedUrl();
      } else {
        this.router.navigate([
          'docout',
          { outlets: { contenido: ['panelmando'] } }
        ]);
      }
    } else if (
      this.router.routerState.snapshot.url.indexOf('/docout') === 0 &&
      this.router.routerState.snapshot.url.indexOf('contenido:detalle') < 0
    ) {
      this.router.navigate([
        'docout',
        { outlets: { contenido: ['panelmando'] } }
      ]);
    }
  }

  public isSsoAuthentication() {
    return this._isSsoAuthentication;
  }


  public loginSSOParameters(parametrosSSO: SolicitudSsoParameter): Observable<any> {
    return this.http
      .post(AUTH_PATH_SSO_PARAMETERS, parametrosSSO)
      .pipe(
        map((response: any) => {

          // login successful if there's a jwt token in the response
          const resp = new AuthResponse(JSON.stringify(response));
          const token = response && resp.token;
          if (token) {
            //// store username and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem(
              'currentUser',
              JSON.stringify({
                username: parametrosSSO.cusu + '@' + parametrosSSO.cliente,
                token: token
              })
            );

            this.loadUserData(true, token);
            return true;
          } else {
            // return false to indicate failed login
            this.setLoggin(false);
            return false;
          }
        })
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.setLoggin(false);
          if (error.status === 409 && error.error === 'Throttle') {
            this.toastr.warning(
              this.translateService.instant('warning.waitForLogin')
            );
          }
          return Observable.throw(error || 'Server error');
        })
      );
	}
	  
  private getIsProveedorUser(): Observable<boolean> {
    return this.http.get<boolean>(IS_PROVEEDOR_PATH);
  }

  isProveedorUser(): Promise<Boolean> {
    return new Promise<Boolean>(resolve => {
      if (this.isProveedorUserLogged !== undefined) {
        resolve(this.isProveedorUserLogged);
      } else {
        this.getIsProveedorUser()
          .pipe(first())
          .subscribe((isProvUser: boolean) => {
            this.isProveedorUserLogged = isProvUser;
            resolve(isProvUser);
          });
      }
    });

  }

}


